import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ExpediteShippingOrderHistoryState } from "@TKCCP/Store/Data/ExpediteShippingOrderHistory/ExpediteShippingOrderHistoryState";
import { ExpediteShippingOrderHistoryModel } from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

const initialState: ExpediteShippingOrderHistoryState = {
    byId: {},
    isLoading: {},
    dataViews: {},
};

const reducer = {
    "Data/ExpediteShippingOrderHistory/BeginLoadExpediteShippingOrderHistory": (
        draft: Draft<ExpediteShippingOrderHistoryState>,
        action: { orderNumber: string },
    ) => {
        draft.isLoading[action.orderNumber] = true;
    },

    "Data/ExpediteShippingOrderHistory/CompleteLoadExpediteShippingOrderHistory": (
        draft: Draft<ExpediteShippingOrderHistoryState>,
        action: { orderNumber: string; model: ExpediteShippingOrderHistoryModel | undefined },
    ) => {
        delete draft.isLoading[action.orderNumber];
        if (action.model) {
            draft.byId[action.orderNumber] = action.model;
        }
    },

    "Data/ExpediteShippingOrderHistory/Reset": () => {
        return initialState;
    },
};

const expediteShippingOrderHistoryReducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).expediteShippingOrderHistory = expediteShippingOrderHistoryReducer;
//(reducers as any).expediteShipping = expediteShippingOrderHistoryReducer;
